import MarketplaceItemView from './MarketplaceItemView.html';
import { MarketplaceItemController } from './MarketplaceItemController';
const MarkeplaceItemComponent = {
    template: MarketplaceItemView,
    controllerAs: '$ctrl',
    controller: MarketplaceItemController,
    bindings: {
        contact: '<',
        planSelect: '=',
        size: '@?',
        planAccount: '<',
    },
};
export default MarkeplaceItemComponent;
